
import React from 'react'
import { FactionStack as StackComponent } from './stacks'

import { GenericItem } from './generic'

export const FactionItem = props => {
  return <GenericItem {...props} StackComponent={StackComponent} />
}

export default FactionItem